import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { extractRowLocations, normalizeLocationFilterValues } from "../utils/locationFilters";

export function getTableLocationSummary(input, { fallback = "-" } = {}) {
  const locations =
    input && typeof input === "object" && !Array.isArray(input)
      ? extractRowLocations(input)
      : normalizeLocationFilterValues([input]);

  if (!locations.length) {
    return {
      locations: [],
      primary: fallback,
      extraCount: 0,
      hasValue: false,
    };
  }

  return {
    locations,
    primary: locations[0],
    extraCount: Math.max(0, locations.length - 1),
    hasValue: true,
  };
}

export default function TableLocationValue({
  row,
  value,
  fallback = "-",
  sx,
  textSx,
  countSx,
  noWrap = true,
}) {
  const summary = React.useMemo(
    () => getTableLocationSummary(row ?? value, { fallback }),
    [fallback, row, value]
  );

  if (!summary.hasValue) {
    return fallback;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.6,
        minWidth: 0,
        ...(sx || {}),
      }}
    >
      <Typography
        noWrap={noWrap}
        sx={{
          minWidth: 0,
          fontSize: 14,
          color: "#475467",
          ...(textSx || {}),
        }}
      >
        {summary.primary}
      </Typography>
      {summary.extraCount > 0 ? (
        <Tooltip
          title={summary.locations.join(" | ")}
          placement="bottom"
          enterDelay={120}
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: "#9C4FFF",
                color: "#FFFFFF",
                borderRadius: 0,
                fontFamily: "Be Vietnam Pro",
                fontSize: 12,
                fontWeight: 300,
                lineHeight: 1.2,
                px: 1.25,
                py: 0.55,
              },
            },
          }}
        >
          <Typography
            component="span"
            sx={{
              flexShrink: 0,
              fontSize: 12,
              fontWeight: 700,
              color: "#8B5CF6",
              ...(countSx || {}),
            }}
          >
            +{summary.extraCount}
          </Typography>
        </Tooltip>
      ) : null}
    </Box>
  );
}
